import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {  Drawer } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard'; 
import HomeIcon from '@material-ui/icons/HomeOutlined'; 
import BriefCaseIcon from '@material-ui/icons/BusinessCenterOutlined';
import PeopleIcon from '@material-ui/icons/PersonOutlined';
import SubscriptionIcon from '@material-ui/icons/CardMembershipOutlined';
import MediaIcon from '@material-ui/icons/PermMediaOutlined';
import MyAccountIcon from '@material-ui/icons/AccountBoxOutlined';
import LogoutIcon from '@material-ui/icons/ExitToAppOutlined';
import LockOpenIcon from '@material-ui/icons/LockOpen'; 
import Button from '@material-ui/core/Button';
import {   SidebarNav } from './components'; 
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import IconButton from '@material-ui/core/IconButton';



const useStyles = makeStyles(theme => ({
  drawer: {
      background: 'rgb(10,18,65)',

  },
  root: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '8px',
    paddingTop: 44,
  },
  divider: {
   
  },
  nav: {
    marginBottom: '8px'
  },
  closebox: {
      cursor: 'pointer',
      borderRadius: 5,
      '&:hover': {
        backgroundColor: '#e8e8e888'
      }
  }
}));

const Sidebar = props =>  {
  const { user, open, variant, onClose, className, ...rest } = props;
  const isAdmin = localStorage.getItem('isAdmin') === 'admin';
  
  const classes = useStyles();

  const pages = [ 
    {
      title: 'Portal Home',
      href: '/',
      icon: <HomeIcon  onClick={onClose} />,
      access: 'all'
    },  
    {
        title: 'My Account',
        href: '/account',
        icon: <MyAccountIcon onClick={onClose} />,
        access: 'all'
      },  
      {
        title: 'Administration',
        href: '/administration',
        icon: <MyAccountIcon onClick={onClose} />,
        access: 'admin'
      },  
    // {
    //   title: 'Subscription',
    //   href: '/subscription',
    //   icon: <SubscriptionIcon onClick={onClose} />
    // }, 
    {
        title: '',      // this is a separator bar
      },
    {
      title: 'Sign Out',
      href: '/signout',
      icon: <LogoutIcon   />,
      access: 'all'
    }
  ];

   
   

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  }; 
   

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
      style={{zIndex: 10002}}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
          >
          <div className={classes.closebox} onClick={onClose}>
                  <IconButton aria-label="close"
                    style={{color: '#594a42', fontWeight: 100}}
                  // onClick={onClose}
                  >
                      <HighlightOffIcon />
                  </IconButton>
                  {/* <div style={{display:'inline-block', verticalAlign: 'middle', color: '#594a42'}}>
                  Close
                  </div> */}
            </div>
       
        <SidebarNav
          className={classes.nav}
          pages={pages}
          onClick={onClose}
          isAdmin={isAdmin}
        /> 
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
